import React from "react";

export default function SectionHeading({ eyebrow, title, align = "left" }) {
    const isCenter = align === "center";
    return (
        <div className={`sau-reveal ${isCenter ? "text-center" : ""}`}>
            <div
                className={`inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[color:var(--sau-accent)] ${
                    isCenter ? "justify-center" : ""
                }`}
            >
                <span className="inline-block w-6 h-px bg-[color:var(--sau-accent)]/70" />
                {eyebrow}
            </div>
            <h2
                className="mt-4 font-semibold tracking-tight text-[color:var(--sau-text)]"
                style={{
                    fontSize: "clamp(1.75rem, 3.4vw, 2.75rem)",
                    lineHeight: 1.1,
                    letterSpacing: "-0.02em",
                }}
            >
                {title}
            </h2>
        </div>
    );
}
